import dayjs from "dayjs";
import { PediatricAssessmentFormData, CreatePediatricAssessmentRequestDto, UpdatePediatricAssessmentRequestDto } from "./model";

export const mapPediatricToApi = (formData: PediatricAssessmentFormData): CreatePediatricAssessmentRequestDto => {
    return {
        PT_ID: 0, // Will be set in the component
        evaulation: formData.evaulation || 0,
        ped_general_view: formData.ped_general_view || 0,
        ped_cardiovascular: formData.ped_cardiovascular || 0,
        ped_respiratory: formData.ped_respiratory || 0,
        ptime: formData.ptime ? dayjs(formData.ptime).format("YYYY-MM-DDTHH:mm:ss") : dayjs().format("YYYY-MM-DDTHH:mm:ss"),
    };
};

export const mapPediatricToUpdateApi = (formData: PediatricAssessmentFormData): UpdatePediatricAssessmentRequestDto => {
    const result: UpdatePediatricAssessmentRequestDto = {};

    if (formData.evaulation !== null && formData.evaulation !== undefined) {
        result.evaulation = Number(formData.evaulation);
    }
    if (formData.ped_general_view !== null && formData.ped_general_view !== undefined) {
        result.ped_general_view = Number(formData.ped_general_view);
    }
    if (formData.ped_cardiovascular !== null && formData.ped_cardiovascular !== undefined) {
        result.ped_cardiovascular = Number(formData.ped_cardiovascular);
    }
    if (formData.ped_respiratory !== null && formData.ped_respiratory !== undefined) {
        result.ped_respiratory = Number(formData.ped_respiratory);
    }
    if (formData.ptime) {
        result.ptime = dayjs(formData.ptime).format("YYYY-MM-DDTHH:mm:ss");
    }

    return result;
};

export const calculatePediatricScore = (
    generalView: number | null | undefined,
    cardiovascular: number | null | undefined,
    respiratory: number | null | undefined
): string => {
    let score = 0;

    if (generalView !== null && generalView !== undefined) {
        score += Number(generalView);
    }
    if (cardiovascular !== null && cardiovascular !== undefined) {
        score += Number(cardiovascular);
    }
    if (respiratory !== null && respiratory !== undefined) {
        score += Number(respiratory);
    }

    return score.toString();
};

export const getPediatricScoreColor = (score: string | number): string => {
    return "transparent";
};

export const isPatientUnder18 = (birthDate: string | null | undefined): boolean => {
    if (!birthDate) return false;

    const birth = new Date(birthDate);
    if (isNaN(birth.getTime())) return false;

    const now = new Date();
    const ageInYears = (now.getTime() - birth.getTime()) / (1000 * 60 * 60 * 24 * 365.25);

    return ageInYears < 18;
};
